import classnames from "classnames";
import {Helmet} from "react-helmet-async";
import {FaCheckCircle} from "react-icons/fa";
import {Link, useSearchParams} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

import css from "./ConfirmationPage.module.css";

export const ConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action");
  let message;
  switch (action) {
    case "subscription":
      message = (
        <>
          Your purchase has been approved. Invoices are available two hours after payment is made and can be found{" "}
          <Link to="/billing/history" target={"_blank"}>
            here
          </Link>
          .<br />
          <br />
          Keep stakeholders aware of recent purchases by designating them to receive invoices via Email{" "}
          <Link to="/accounts/user-management" target={"_blank"}>
            here
          </Link>
          .
        </>
      );
      break;
    case "payment-method":
      message = <>Your updates have been saved.</>;
      break;
    case "custom-request":
      message = (
        <>
          Thank you for your interest in a Custom monitoring configuration. We’ll reach out within 24 hours to discuss a
          configuration that meets your needs and requirements.
        </>
      );
      break;
    default:
      message = (
        <>
          Downtime is hard enough. That’s why we’ve made it easy to add on anything at any time that achieves more
          uptime.
        </>
      );
  }
  const {user} = useCurrentUserContext();
  const hasFreeTrial = user && user.account.free_trial_expires_at;
  return (
    <>
      <Helmet>
        <title>Thank You</title>
      </Helmet>
      <UpErrorBoundary>
        <div className="d-flex flex-row justify-content-center align-items-center vh-100 min-vh-100">
          <div className={classnames(css.ConfirmationContainer, "d-flex flex-column align-items-center text-center")}>
            <FaCheckCircle size="100px" className={css.CheckIcon} />
            <h2 className="fw-bold fst-normal fs-2 lh-md mt-4">Thank You!</h2>
            <p className="d-block fst-normal fw-normal fs-6 mt-4">{message}</p>
            {hasFreeTrial && (
              <Button as={Link} to={"/billing/subscribe"} target={"_blank"} className="mt-4">
                Go to Subscribe
              </Button>
            )}
          </div>
        </div>
      </UpErrorBoundary>
    </>
  );
};
